import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const openLine = () => {
    window.open('https://line.me/R/ti/p/@939rzwem', '_blank');
  };

  return (
    <footer className="bg-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">好野貸</h3>
            <p className="text-gray-300 mb-4">
              專業的借貸服務平台，致力於為每位客戶提供最適合的貸款方案，
              讓您的資金需求得到最快速、最安全的解決方案。
            </p>
            <div className="text-gray-300">
              <p className="mb-2">
                <span className="font-semibold">LINE 官方帳號：</span>
                <span className="font-mono">@939rzwem</span>
              </p>
              <p>服務時間：週一至週五 9:00-18:00</p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-4">快速連結</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-gray-300 hover:text-white transition-colors duration-200"
                >
                  首頁
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="text-gray-300 hover:text-white transition-colors duration-200"
                >
                  成功案例
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-gray-300 hover:text-white transition-colors duration-200"
                >
                  關於我們
                </Link>
              </li>
              {isHomePage && (
                <>
                  <li>
                    <button
                      onClick={openLine}
                      className="text-gray-300 hover:text-white transition-colors duration-200"
                    >
                      聯絡我們
                    </button>
                  </li>
                </>
              )}
            </ul>
          </div>

          {/* Contact & Legal */}
          <div>
            <h3 className="text-xl font-bold mb-4">聯絡資訊</h3>
            <div className="space-y-2 text-gray-300 mb-6">
              <p>服務時間：週一至週五 9:00-18:00</p>
              <p>24小時 LINE 線上諮詢</p>
              <p>LINE ID: @939rzwem</p>
            </div>
            <div className="space-y-2">
              <a
                href="https://line.me/R/ti/p/@939rzwem"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center bg-green-500 text-white px-4 py-2 rounded-lg hover:bg-green-600 transition-colors duration-200"
              >
                <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
                  <path d="M12 6c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/>
                </svg>
                LINE 諮詢
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p className="text-gray-300">
            © {currentYear} 好野貸. 版權所有 | 提醒您：借錢不還，再借困難！
          </p>
          <p className="text-gray-400 text-sm mt-2">
            實際貸款條件以銀行或貸款機構核准為準，本網站僅提供資訊諮詢服務
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;